import React from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>梦核相机</h1>
      <h2>文档页面</h2>
      <ul>
        <li>
          <Link to="/terms/marketing">产品介绍</Link>
        </li>
        <li><Link to="/terms/marketing-en">Product overview (English)</Link></li>
        <li><Link to="/terms/support">帮助与支持</Link></li>
        <li><Link to="/terms/support-en">Help &amp; Support (English)</Link></li>
        <li>
          <Link to="/terms/eula">用户协议</Link>
        </li>
        <li>
          <Link to="/terms/privacy-policy">隐私政策</Link>
        </li>
        <li>
          <Link to="/terms/eula-en">用户协议（英文）</Link>
        </li>
        <li>
          <Link to="/terms/privacy-policy-en">隐私政策（英文）</Link>
        </li>
      </ul>
      <footer style={{ marginTop: '50px', textAlign: 'center' }}>
        <p style={{ fontSize: '12px', color: '#999' }}>
          沪ICP备2025136834号-2
        </p>
      </footer>
    </div>
  );
};

export default HomePage;
